import { Set } from 'immutable';

/* eslint-disable-next-line import/prefer-default-export */
export function keyIn(keys) {
  const keySet = Set(keys);
  return function (v, k) {
    return keySet.has(k);
  };
}
